__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@immense-ui/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@immense-ui/core", "1.0.0", () => (Promise.all([__webpack_require__.e(9), __webpack_require__.e(765), __webpack_require__.e(381), __webpack_require__.e(588), __webpack_require__.e(915), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(71588))))));
			register("@material-ui/styles", "4.11.5", () => (Promise.all([__webpack_require__.e(919), __webpack_require__.e(381), __webpack_require__.e(58)]).then(() => (() => (__webpack_require__(77919))))));
			register("@rollbar/react", "1.0.0", () => (Promise.all([__webpack_require__.e(405), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(90405))))));
			register("axios", "1.13.2", () => (__webpack_require__.e(267).then(() => (() => (__webpack_require__(74267))))));
			register("react-cookie", "8.0.1", () => (Promise.all([__webpack_require__.e(667), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(33667))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(485), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(28485))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e(713), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(70713))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(381), __webpack_require__.e(855), __webpack_require__.e(209)]).then(() => (() => (__webpack_require__(10426))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(381), __webpack_require__.e(248)]).then(() => (() => (__webpack_require__(91513))))));
			register("react", "18.3.1", () => (__webpack_require__.e(552).then(() => (() => (__webpack_require__(7552))))));
			initExternal(84007);
			initExternal(72535);
			initExternal(31735);
			initExternal(11571);
			initExternal(52301);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};